// Shared query constants for the /copilot/agents views. This is a lightweight
// module so consumers (e.g. AgentsTaskList) can import a single constant without
// pulling in the whole AgentsSidebar module (CSS + UI components).

import {FILTER_STATUS_NEEDS_ATTENTION, STATUS_QUALIFIER} from '../../utils/filter-utils'

// The /copilot/agents task list is always scoped to the current user, so we no
// longer encode `author:@me` in the URL (it's applied implicitly). Defaulting to
// `is:open` selects the Active tab.
export const CREATED_BY_ME_QUERY = 'is:open'
export const NEEDS_ATTENTION_QUERY = `is:open ${STATUS_QUALIFIER}${FILTER_STATUS_NEEDS_ATTENTION}`

export function getCreatedByMeSearchParams(): URLSearchParams {
  const params = new URLSearchParams()
  params.set('q', CREATED_BY_ME_QUERY)
  return params
}
